<template>
    <div class="training-step3">
        <div class="training-step3-title">
            <img src="@/assets/images/icon_zhuangshi@2x.png" alt="">
            <span>人员安排</span>
        </div>
        <div>
            <el-form :model="formData" :rules="formData.status !== 7 ? rules : {}" ref="form" label-width="200px" key="2" class="training-step3-form">
                <el-form-item label="报名参与：" class="long-item">
                    <el-checkbox v-model="audience" @change="audienceChange" :disabled="formData.status !== 7 ? false : true">参与报名</el-checkbox>
                    <span class="item-tip">（受众范围内的学员可参与报名）</span>
                </el-form-item>
                <el-form-item v-if="audience" label="报名开始时间：" prop="joinStartTime">
                    <el-date-picker v-model="formData.joinStartTime" type="datetime" placeholder="请选择开始时间" :clearable="false" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formData.status !== 7 ? false : true"></el-date-picker>
                </el-form-item>
                <el-form-item v-if="audience" label="报名截止时间：" prop="joinEndTime" class="spec-item-label">
                    <el-date-picker v-model="formData.joinEndTime" type="datetime" placeholder="请选择截止时间" :clearable="false" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formData.status !== 7 ? false : true"></el-date-picker>
                </el-form-item>
                <el-form-item v-if="audience" label=" 报名范围：" prop="trainWhitelists" class="spec-item-content">
                    <div class="spec-item-choose-container">
                        <div class="spec-item-choose">
                            <!-- // 0/全部,1/用户,2/部门,3/职务,4/岗位 -->
                            <template v-for="(item, index) in formData.trainWhitelists">
                                <el-tag v-if="item.type == 2" type="info" :key="index" size="medium" :closable="formData.status !== 7 ? true : false" @close="closeWhiteUser(item, index)">部门：{{item.relName}}</el-tag>
                                <el-tag v-if="item.type == 1" type="success" :key="index" size="medium" :closable="formData.status !== 7 ? true : false" @close="closeWhiteUser(item, index)">用户：{{item.relName}}</el-tag>
                                <el-tag v-if="item.type == 4" type="danger" :key="index" size="medium" :closable="formData.status !== 7 ? true : false" @close="closeWhiteUser(item, index)">岗位：{{item.relName}}</el-tag>
                                <el-tag v-if="item.type == 3" type="warning" :key="index" size="medium" :closable="formData.status !== 7 ? true : false" @close="closeWhiteUser(item, index)">职位：{{item.relName}}</el-tag>
                            </template>
                        </div>
                        <div class="spec-btns" v-if="formData.status !== 7">
                            <el-button size="mini" @click="clearAllWhiteUser">清空</el-button>
                            <el-button size="mini" @click="addWhiteUser">添加</el-button>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item v-if="audience" label="报名需要审核：" prop="needReview">
                    <el-radio-group v-model="formData.needReview" :disabled="formData.status !== 7 ? false : true">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <div class="training-step3-line"></div>
        <div class="training-step3-btn-wrap">
            <div class="title">指定人员</div>
            <div class="training-step-right-btns" v-if="formData.status !== 7">
                <el-button size="mini" @click="addStudent">添加学员</el-button>
                <el-button size="mini" @click="removeStudent">删除</el-button>
            </div>
        </div>
        <div class="training-step-table">
            <el-table :data="formData.trainStudents" style="width: 100%" @selection-change="handleStudentTableSeleChange">
                <template slot="empty">
                    <EmptyPage></EmptyPage>
                </template>
                <el-table-column type="selection" width="55" v-if="formData.status !== 7"></el-table-column>
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="realname" label="姓名"></el-table-column>
                <el-table-column prop="username" label="账号"></el-table-column>
                <el-table-column prop="sex" label="性别">
                    <template slot-scope="scope">
                        <span>{{sexObj[scope.row.sex]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="orgName" label="归属部门"></el-table-column>
                <el-table-column prop="positionName" label="职务"></el-table-column>
                <el-table-column prop="mobile" label="手机"></el-table-column>
                <el-table-column prop="action" label="操作" width="150" v-if="formData.status !== 7">
                    <template slot-scope="scope">
                        <div class="table-btn table-btn-delete" @click="deleteItem(scope.$index)">
                            <i class="el-icon-delete"></i>
                            <span>删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="training-step-btns" v-if="formData.status !== 7">
            <el-button type="primary" size="mini" @click="stepSave">保存</el-button>
        </div>
        <!-- 学员 -->
        <el-dialog
            :title="userDailog.title"
            :visible.sync="userDailog.visible"
            width="10rem"
            class="step-audit-dialog"
            key="userdialog"
            :before-close="handleUserDialogClose">
            <el-form :model="userDailog.form" :inline="true" label-width="100px" key="3" class="user-step-search-form">
                <el-form-item label="姓名：" prop="realname">
                    <el-input v-model="userDailog.form.realname"></el-input>
                </el-form-item>
                <el-form-item label="账号：" prop="username">
                    <el-input v-model="userDailog.form.username"></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="mobile">
                    <el-input v-model="userDailog.form.mobile"></el-input>
                </el-form-item>
                <el-form-item label="" class="search-itrm-btn">
                    <el-button size="mini" @click="handleUserDialogSearch('student')">查询</el-button>
                    <el-button size="mini" class="reset-btn" @click="handleUserDialogReset('student')">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="training-step-table">
                <el-table :data="userDailog.tableForm.formResult.list" style="width: 100%" key="coursetable" @selection-change="handleUserTableSeleChange">
                    <el-table-column key="usercol1" type="selection"></el-table-column>
                    <el-table-column key="usercol2" type="index" label="序号"></el-table-column>
                    <el-table-column key="usercol3" prop="username" label="用户账号"></el-table-column>
                    <el-table-column key="usercol4" prop="realname" label="姓名"></el-table-column>
                    <el-table-column key="usercol5" prop="mobile" label="手机号码"></el-table-column>
                    <el-table-column key="usercol6" prop="orgName" label="部门"></el-table-column>
                    <el-table-column key="usercol7" prop="jobName" label="岗位"></el-table-column>
                    <el-table-column key="usercol8" prop="positionName" label="职务"></el-table-column>
                    <el-table-column key="usercol9" prop="isPublish" label="状态">
                        <template slot-scope="scope">
                            <span>{{scope.row.isPublish ? '已发布' : '未发布'}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination key="userpage" @request-form-list="queryUserList('student')" :form="userDailog.tableForm"></pagination>
            </div>
            <div class="dialog-footer">
                <el-button type="primary" size="mini" @click="handleUserDialogSave">保存</el-button>
            </div>
        </el-dialog>
        <!-- 授权 -->
        <el-dialog
            :title="audienceDailog.title"
            :visible.sync="audienceDailog.visible"
            width="10rem"
            class="step-audit-dialog step-audienced-dialog"
            key="audiencedialog"
            :before-close="handleAudienceDialogClose">
            <SectionTab :active="audienceDailog.activeTab" :list="audienceDailog.tabList" @handleTabChange="handleTabChange"></SectionTab>
            <div class="training-step-tree" v-show="audienceDailog.activeTab === 3">
                <el-tree
                    :data="audienceDailog.depart.list"
                    show-checkbox
                    default-expand-all
                    node-key="id"
                    ref="tree"
                    highlight-current
                    :props="{label: 'name', value: 'id', children: 'orgs'}">
                </el-tree>
            </div>
            <div v-show="audienceDailog.activeTab === 1">
                <el-form :model="audienceDailog.user.form" :inline="true" label-width="100px" key="a1" class="user-step-search-form">
                    <el-form-item label="姓名：" prop="realname">
                        <el-input v-model="audienceDailog.user.form.realname"></el-input>
                    </el-form-item>
                    <el-form-item label="账号：" prop="username">
                        <el-input v-model="audienceDailog.user.form.username"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号：" prop="mobile">
                        <el-input v-model="audienceDailog.user.form.mobile"></el-input>
                    </el-form-item>
                    <el-form-item label="" class="search-itrm-btn">
                        <el-button size="mini" @click="handleUserDialogSearch('aud')">查询</el-button>
                        <el-button size="mini" class="reset-btn" @click="handleUserDialogReset('aud')">重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="training-step-table">
                    <el-table :data="audienceDailog.user.tableForm.formResult.list" style="width: 100%" key="ausertable" @selection-change="handleAUserTableSeleChange">
                        <el-table-column key="ausercol1" type="selection"></el-table-column>
                        <el-table-column key="ausercol2" type="index" label="序号"></el-table-column>
                        <el-table-column key="ausercol3" prop="username" label="用户账号"></el-table-column>
                        <el-table-column key="ausercol4" prop="realname" label="姓名"></el-table-column>
                        <el-table-column key="ausercol5" prop="mobile" label="手机号码"></el-table-column>
                        <el-table-column key="ausercol6" prop="orgName" label="部门"></el-table-column>
                        <el-table-column key="ausercol7" prop="jobName" label="岗位"></el-table-column>
                        <el-table-column key="ausercol8" prop="positionName" label="职务"></el-table-column>
                        <el-table-column key="ausercol9" prop="isPublish" label="状态">
                            <template slot-scope="scope">
                                <span>{{scope.row.isPublish ? '已发布' : '未发布'}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination key="auserepage" @request-form-list="queryUserList('aud')" :form="audienceDailog.user.tableForm"></pagination>
                </div>
            </div>
            <div v-show="audienceDailog.activeTab === 2">
                <el-form :model="audienceDailog.job.form" :inline="true" label-width="100px" key="a2" class="user-step-search-form">
                    <el-form-item label="岗位名称：" prop="name">
                        <el-input v-model="audienceDailog.job.form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="" class="search-itrm-btn">
                        <el-button size="mini" @click="handleJobDialogSearch">查询</el-button>
                        <el-button size="mini" class="reset-btn" @click="handleJobDialogReset">重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="training-step-table">
                    <el-table :data="audienceDailog.job.tableForm.formResult.list" style="width: 100%" key="ajobable" @selection-change="handleAJobTableSeleChange">
                        <el-table-column key="ajobcol1" type="selection"></el-table-column>
                        <el-table-column key="ajobcol2" type="index" label="序号"></el-table-column>
                        <el-table-column key="ajobcol3" prop="name" label="岗位名称"></el-table-column>
                        <el-table-column key="jobcol4" prop="depName" label="所属部门"></el-table-column>
                    </el-table>
                    <pagination key="ajobpage" @request-form-list="queryJobList" :form="audienceDailog.job.tableForm"></pagination>
                </div>
            </div>
            <div v-show="audienceDailog.activeTab === 4">
                <el-form :model="audienceDailog.pos.form" :inline="true" label-width="100px" key="a3" class="user-step-search-form">
                    <el-form-item label="职务名称：" prop="name">
                        <el-input v-model="audienceDailog.pos.form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="" class="search-itrm-btn">
                        <el-button size="mini" @click="handlePosDialogSearch">查询</el-button>
                        <el-button size="mini" class="reset-btn" @click="handlePosDialogReset">重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="training-step-table">
                    <el-table :data="audienceDailog.pos.tableForm.formResult.list" style="width: 100%" key="apostable" @selection-change="handleAPosTableSeleChange">
                        <el-table-column key="aposcol1" type="selection"></el-table-column>
                        <el-table-column key="aposcol2" type="index" label="序号"></el-table-column>
                        <el-table-column key="aposcol3" prop="name" label="职务名称"></el-table-column>
                        <el-table-column key="aposcol4" prop="depName" label="所属部门"></el-table-column>
                    </el-table>
                    <pagination key="apospage" @request-form-list="queryPosList" :form="audienceDailog.pos.tableForm"></pagination>
                </div>
            </div>
            <div class="dialog-footer">
                <el-button type="primary" size="mini" @click="handleAudienceDialogSave">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import EmptyPage from '@/components/emptyPage'
import pagination from '@/components/pagination/index'
import SectionTab from './sectionTab.vue'

export default {
    name: 'TrainingStep3',
    props: ['formData'],
    components: { EmptyPage, pagination, SectionTab },
    data() {
        return {
            rules: {
                joinStartTime: [
                    { required: true, message: '请选择报名开始时间', trigger: 'change' },
                ],
                joinEndTime: [
                    { required: true, message: '请选择报名截止时间', trigger: 'change' },
                ],
            },
            sexObj: {0: '男', 1: '女', 2: '保密' },
            relType: {0: '全部', 1: '用户', 2: '岗位', 3: '部门', 4: '职务', 5: '用户类型'},
            audience: true,
            selectedStudent: null,
            userDailog: {
                visible: false,
                title: '选择学员',
                form: {
                    realname: '',
                    username: '',
                    mobile: ''
                },
                tableForm: {
                    formResult: { currentPage: 1, list: [], total: 0 },
                    pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
                },
                selectedUser: []
            },
            audienceDailog: {
                visible: false,
                title: '选择受众对象',
                activeTab: 3,
                tabList: [
                    {id: 3, name: '部门'},
                    {id: 1, name: '人员'},
                    {id: 4, name: '职务'},
                    {id: 2, name: '岗位'}
                ],
                depart: {
                    list: []
                },
                user: {
                    form: {
                        realname: '',
                        username: '',
                        mobile: ''
                    },
                    tableForm: {
                        formResult: { currentPage: 1, list: [], total: 0 },
                        pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
                    },
                    selectedUser: null
                },
                pos: {
                   form: {
                        name: ''
                    },
                    tableForm: {
                        formResult: { currentPage: 1, list: [], total: 0 },
                        pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
                    },
                    selectedData: null 
                },
                job: {
                    form: {
                        name: ''
                    },
                    tableForm: {
                        formResult: { currentPage: 1, list: [], total: 0 },
                        pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
                    },
                    selectedData: null 
                }
            }
        }
    },
    mounted() {
        if (this.formData.trainWhitelists && this.formData.trainWhitelists.length > 0) {
            this.audience = true
        } else {
            this.audience = false
        }
    },
    methods: {
        // 报名切换
        audienceChange() {
            this.clearAllWhiteUser()
        },
        // 添加白名单
        addWhiteUser() {
            this.audienceDailog.visible = true
            this.getOrgTreeList()
            this.handleUserDialogReset('aud')
            this.handlePosDialogReset()
            this.handleJobDialogReset()
        },
        // 删除白名单
        clearAllWhiteUser() {
            this.formData.trainWhitelists = []
        },
        closeWhiteUser(item, index) {
            this.formData.trainWhitelists.splice(index, 1)
        },
        handleTabChange(item) {
            this.audienceDailog.activeTab = item.id
        },
        handleAudienceDialogClose() {
            this.audienceDailog.visible = false
        },
        handleAudienceDialogSave() {
            // 0/全部,1/用户,2/部门,3/职务,4/岗位
            let chkDeparts = this.$refs.tree.getCheckedNodes()
            let departs = []
            let userIds = []
            let posIds = []
            let jobIds = []
            for (let item of this.formData.trainWhitelists) {
                if (item.type === 1) {
                    userIds.push(item.relId)
                }
                if (item.type === 3) {
                    departs.push(item.relId)
                }
                if (item.type === 2) {
                    jobIds.push(item.relId)
                }
                if (item.type === 4) {
                    posIds.push(item.relId)
                }
            }
            // 部门
            if (chkDeparts && chkDeparts.length > 0) {
                for (let item of chkDeparts) {
                    if (departs.indexOf(item.id) === -1) {
                        this.formData.trainWhitelists.push({
                            orgName: item.name,
                            relName: item.name,
                            relId: item.id,
                            type: 2
                        })
                    }
                }
            }
            // 人员
            if (this.audienceDailog.user.selectedUser) {
                for (let item of this.audienceDailog.user.selectedUser) {
                    if (userIds.indexOf(item.id) === -1) {
                        this.formData.trainWhitelists.push({
                            orgName: item.orgName,
                            relName: item.realname,
                            relId: item.id,
                            type: 1
                        })
                    }
                }
            }
            // 职务
            if (this.audienceDailog.pos.selectedData) {
                for (let item of this.audienceDailog.pos.selectedData) {
                    if (posIds.indexOf(item.id) === -1) {
                        this.formData.trainWhitelists.push({
                            orgName: item.depName,
                            relName: item.name,
                            relId: item.id,
                            type: 3
                        })
                    }
                }
            }
            // 岗位
            if (this.audienceDailog.job.selectedData) {
                for (let item of this.audienceDailog.job.selectedData) {
                    if (jobIds.indexOf(item.id) === -1) {
                        this.formData.trainWhitelists.push({
                            orgName: item.depName,
                            relName: item.name,
                            relId: item.id,
                            type: 4
                        })
                    }
                }
            }
            this.handleAudienceDialogClose()
        },
        // 部门
        getOrgTreeList() {
            this.$nextTick(() => {
                this.$refs.tree.setCheckedKeys([]);
                this.$api.user.baseInfo.orgTreeList({name: '', orgManage: 1}).then(res => {
                    this.audienceDailog.depart.list = res.data
                })
            })
        },
        handleAUserTableSeleChange(data) {
            this.audienceDailog.user.selectedUser = data
        },
        handleJobDialogSearch() {
            this.audienceDailog.job.tableForm.pageData.currentPage = 1
            this.queryJobList()
        },
        handleJobDialogReset() {
            this.audienceDailog.job.form.name = ''
            this.audienceDailog.job.tableForm.pageData.currentPage = 1
            this.audienceDailog.job.selectedData = null
            this.queryJobList()
        },
        handleAJobTableSeleChange(data) {
            this.audienceDailog.job.selectedData = data
        },
        queryJobList() {
            this.$api.user.baseInfo.positionList({
                formData: {
                    type: 3,
                    name: this.audienceDailog.job.form.name
                },
                pageData: this.audienceDailog.job.tableForm.pageData
            }).then(res => {
                this.audienceDailog.job.tableForm.formResult = res.data
            })
        },
        handlePosDialogSearch() {
            this.audienceDailog.pos.tableForm.pageData.currentPage = 1
            this.queryPosList()
        },
        handlePosDialogReset() {
            this.audienceDailog.pos.form.name = ''
            this.audienceDailog.pos.tableForm.pageData.currentPage = 1
            this.audienceDailog.pos.selectedData = null
            this.queryPosList()
        },
        handleAPosTableSeleChange(data) {
            this.audienceDailog.pos.selectedData = data
        },
        queryPosList() {
            this.$api.user.baseInfo.positionList({
                formData: {
                    type: 2,
                    name: this.audienceDailog.pos.form.name
                },
                pageData: this.audienceDailog.pos.tableForm.pageData
            }).then(res => {
                this.audienceDailog.pos.tableForm.formResult = res.data
            })
        },
        // 添加学员
        addStudent() {
            this.handleUserDialogReset('student')
            this.userDailog.visible = true
        },
        // 删除学员
        removeStudent() {
            if (!this.selectedStudent) {
                this.$message({message: '请选择数据', type: 'warning'})
                return
            }
            for (let item of this.selectedStudent) {
                let index = this.formData.trainStudents.indexOf(item)
                this.formData.trainStudents.splice(index, 1)
            }
            this.selectedStudent = null
        },
        deleteItem(index) {
            this.formData.trainStudents.splice(index, 1)
        },
        // 学员选择
        handleStudentTableSeleChange(data) {
            this.selectedStudent = data
        },
        handleUserDialogClose() {
            this.userDailog.visible = false
        },
        handleUserDialogSearch(type) {
            if (type === 'student') {
                this.userDailog.tableForm.pageData.currentPage = 1
            } else {
                this.audienceDailog.user.tableForm.pageData.currentPage = 1
            }
            this.queryUserList(type)
        },
        handleUserDialogReset(type) {
            if (type === 'student') {
                this.userDailog.form = {
                    realname: '',
                    username: '',
                    mobile: ''
                }
                this.userDailog.tableForm.pageData.currentPage = 1
                this.userDailog.selectedUser = null
            } else {
                this.audienceDailog.user.form = {
                    realname: '',
                    username: '',
                    mobile: ''
                }
                this.audienceDailog.user.tableForm.pageData.currentPage = 1
                this.audienceDailog.user.selectedUser = null
            }
            this.queryUserList(type)
        },
        handleUserTableSeleChange(data) {
            this.userDailog.selectedUser = data
        },
        handleUserDialogSave() {
            if (this.userDailog.selectedUser) {
                let userIds = []
                for (let item of this.formData.trainStudents) {
                    userIds.push(item.userId)
                }
                for (let item of this.userDailog.selectedUser) {
                    if (userIds.indexOf(item.id) === -1) {
                        this.formData.trainStudents.push({
                            jobName: item.jobName,
                            mobile: item.mobile,
                            orgName: item.orgName,
                            realname: item.realname,
                            status: item.status,
                            trainId: this.$route.query.id,
                            userId: item.id,
                            username: item.username,
                            positionName: item.positionName,
                            sex: item.sex
                        })
                    }
                }
            }
            this.handleUserDialogClose()
        },
        stepSave() {
            this.$emit('stepSave')
        },
        queryUserList(type) {
            this.$api.user.baseInfo.userList({
                formData: this.userDailog.form,
                pageData: this.userDailog.tableForm.pageData
            }).then(res => {
                if (type == 'student') {
                    this.userDailog.tableForm.formResult = res.data
                } else {
                    this.audienceDailog.user.tableForm.formResult = res.data
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../../styles/variables.scss';

.training-step3 {
    background: $white_bg_color;
    .training-step3-title {
        padding: .1rem .1rem .16rem;
        font-size: .18rem;
        color: $font__color_000;
        img {
            width: .22rem;
            margin-right: .1rem;
            vertical-align: middle;
        }
    }

    .training-step3-line {
        margin: 0 .2rem;
        border-top: 1px solid $grey_border_color_e6;
    }

    .training-step3-btn-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: .15rem;
        .title {
            font-size: .14rem;
            color: $font_color_51b;
        }
    }
    
    .training-step-right-btns {
        text-align: right;
        padding-right: .22rem;
        height: .3rem;
        .el-button--mini {
            vertical-align: top;
            width: .8rem;
            padding: .07rem .1rem;
        }
    }
    .training-step-table {
        padding: 0 .22rem 0 .1rem;
    }
    .training-step-btns {
        height: .83rem;
        padding: .24rem 0 .3rem;
        border-top: 1px solid $grey_border_color_e6;
        text-align: center;
        .el-button {
            vertical-align: top;
            width: .9rem;
        }
    }
}
</style>
<style lang="scss">
@import '../../../styles/variables.scss';
@import '../../../styles/mixin.scss';

.training-step3 {
    .training-step3-form {
        @include clear-float();
        .el-input.is-disabled .el-input__inner {
            background-color: transparent;
            border-color: transparent;
            color: #333333;
        }
        .el-input.is-disabled .el-input__icon {
            display: none;
        }
        .el-input.is-disabled.el-input--suffix .el-input__inner {
            padding-left: .15rem;
        }
        .el-form-item {
            float: left;
            width: 50%;
            margin-bottom: .16rem;
            .el-input__inner {
                width: 3.6rem;
            }
            .item-tip {
                font-size: .12rem;
                color: $grey_border_color_ccc;
            }
            .el-checkbox__label {
                color: $grey_font_color_80;
                font-size: .14rem;
                font-weight: 400;
            }
            &.spec-item-content {
                width: 100%;
            }
        }
        .long-item {
            width: 100%;
            .el-input__inner {
                width: 6.1rem;
            }
            
        }
        
        .spec-item-label {
            .el-form-item__label {
                margin-left: 20px!important;
                &+.el-form-item__content {
                    margin-left: 220px!important;
                }
            }
        }

        .spec-item-choose-container {
            position: relative;
            width: 9.8rem;
            min-height: .8rem;
            border: 1px solid $grey_border_color_ddd;
            border-radius: .03rem;
            .spec-item-choose {
                width: 7.5rem;
                padding: .1rem;
                .el-tag {
                    vertical-align: top;
                    margin-right: .1rem;
                    margin-bottom: .1rem;
                }
            }
            .spec-btns {
                position: absolute;
                right: .86rem;
                bottom: .1rem;
            }
        }

        .training-step-border {
            width: 6.1rem;
            min-height: .4rem;
            padding: .06rem .08rem;
            border-radius: .04rem;
            border: 1px solid $grey_border_color_ddd;
        }
    }

    .training-step-tree {
        margin: .2rem;
        padding: 0 .1rem;
        max-height: 6rem;
        border: 1px solid $grey_border_color_ddd;
        overflow-y: auto;
    }
    .training-step-table {
        .red {
            margin-right: .04rem;
            color: $font_color_F0;
        }
        .el-table {
            margin-bottom: .3rem;
            th {
                background: $grey_bg_color_f5;
            }
            td, th {
                padding: .1rem 0;
            }
            thead {
                color: $font_color_4A;
            }
            td, th.is-leaf {
                border: 0;
            }
            &::before {
                height: 0;
            }
            .table-btn {
                display: inline-block;
                font-size: .13rem;
                cursor: pointer;
                &:hover {
                    opacity: .8;
                }
                i {
                    font-size: .16rem;
                    vertical-align: text-bottom;
                }
                >span {
                    margin-left: .04rem;
                }
            }
            .table-btn-delete {
                color: $font_color_2A;
            }
            .table-btn-view {
                color: $font_color_51b;
                margin-right: .3rem;
            }
            .table-act-name {
                width: 1.95rem;
            }
            .el-input__inner {
                height: .35rem;
                line-height: .35rem;
            }
            .el-date-editor.el-input, .el-date-editor.el-input__inner {
                width: 1.58rem;
            }
            .el-icon-time {
                display: none;
            }
            .el-input--prefix .el-input__inner {
                padding-left: .15rem;
            }
            .el-select {
                width: 1.5rem;
            }
            .el-input__icon {
                line-height: .35rem;
            }
        }
    }
    .step-audit-dialog {
        .user-step-dialog-form {
            margin-top: .4rem;
            .el-input,.el-textarea,.el-date-editor {
                width: 4rem;
            }
            .el-form-item {
                margin-bottom: .15rem;
            }
            .el-textarea__inner {
                height: .8rem;
            }
        }
        .dialog-footer {
            padding: .15rem .35rem;
            border-top: 1px solid $grey_border_color_e6;
            text-align: right;
            .el-button {
                width: .9rem;
                vertical-align: top;
            }
        }
        .training-step-table {
            padding: 0 .2rem;
        }
        .user-step-search-form {
            margin-top: .2rem;
            .el-input {
                width: 1.7rem;
            }
            .el-form-item {
                margin-bottom: .2rem;
            }
            .search-itrm-btn {
                margin-left: .12rem;
                .reset-btn {
                    color: $font_color_A6;
                }
            }
            .search-item-long-btn {
                margin-left: 3.36rem;
            }
        }
        .user-step-split-form {
            margin-top: .2rem;
            .el-form-item {
                margin-right: 0;
            }
            .form-left-item {
               .el-form-item__label {
                   width: 1.6rem;
               } 
            }
            .form-right-item {
               .el-form-item__label {
                   width: 1.5rem;
               } 
            }
            .el-input {
                width: 2.4rem;
            }
            .job-time-item.el-range-editor {
                width: 2.4rem;
            }
            .el-textarea {
                width: 6.17rem;
            }
        }
        .step-exam-border {
            padding: .2rem .2rem 0 .5rem;
        }
    }
    .step-audienced-dialog {
        .el-dialog__body {
            .section-tab-wrap {
                margin: 0 .2rem;
            }
        }
    }
}
</style>
